import { arrayMap, arraySlice, arrayUnique } from '@/app/utils/nativeArray';
import type { State } from './state';

const parseToFontsArrayString = (fonts: any[]) => {
  return arrayMap(fonts, (font) => font.styleName)
    .sort()
    .join(',');
};

const getters = {
  pageFonts: (state: State) => {
    const fonts: Record<string, any> = [
      {
        googleName: 'Default',
        styleName: 'inherit',
        fontWeight: '',
        custom: true,
      },
    ];
    const optionalFonts = arrayUnique(state.optionFonts, {
      comparetor: (font1, font2) => {
        return font1.styleName === font2.styleName;
      },
    });
    return fonts.concat(optionalFonts);
  },
  showFontManager: (state: State) => state.showFontManager > 0,
  allGoogleFontsState: (state: State) => state.allGoogleFonts,
  googleFontsCss: (state: State) => {
    if (state.showFontManager < 0) {
      return '';
    }
    const FONT_GROUP_LENGTH = state.googleFontsScrollStep;
    const allGoogleFonts = state.allGoogleFonts;
    const maxLength = allGoogleFonts.length;
    const maxGroup = Math.round(maxLength / FONT_GROUP_LENGTH);
    const fontFamiliesImport = [];

    for (let i = 0; i < maxGroup; i++) {
      const startIndex = i * FONT_GROUP_LENGTH;
      const endIndex = startIndex + FONT_GROUP_LENGTH;
      const fontFamilies = arraySlice(allGoogleFonts, startIndex, endIndex, (item) => item.googleName) as string[];
      const sampleText = `${state.sampleText}${arrayMap(fontFamilies, (styleName) => styleName.replace(' ', '')).join(
        '',
      )}Heading123456Paragraph`;
      const fontFamiliesParams = arrayMap(fontFamilies, (styleName) => `family=${styleName}`);

      fontFamiliesImport.push(
        `@import url('https://fonts.googleapis.com/css2?display=swap&text=${sampleText}&${fontFamiliesParams.join(
          '&',
        )}');`,
      );
    }

    return fontFamiliesImport.join('');
  },
  optionedIsChanged(state: State) {
    const optionsValue = parseToFontsArrayString(state.optionFonts);
    const activeValue = parseToFontsArrayString(state.activeFonts);
    return optionsValue !== activeValue || state.changeInstalledFonts || state.changeThemeFonts;
  },
  isEditMode: (state: State) => state.editingFonts.length > 0,
  newInstalledFonts: (state: State) => state.newInstalledFonts,
  uploadStatus: (state: State) => state.uploadStatus,
  themeFonts: (state: State) => state.themeFonts,
  optionFonts: (state: State) => state.optionFonts,
  uploadNumber: (state: State) => state.uploadNumber,
  fontFilesAccept: (state: State) => state.fontFileTypes.map((type) => `.${type}`).join(', '),
};

export default getters;
